/** Shared API base URL and auth token storage for App + AdminDashboard. */

export const SESSION_TOKEN_KEY = "climatetech_token";

const PRODUCTION_API = "https://eloplus.onrender.com";

export function resolveApiBase(): string {
  const fromEnv = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
    return PRODUCTION_API;
  }
  return "http://127.0.0.1:8000";
}

export const API_BASE = resolveApiBase();

export function readStoredToken(): string | null {
  try {
    if (typeof localStorage === "undefined") return null;
    const t = localStorage.getItem(SESSION_TOKEN_KEY);
    if (t && t.length > 0) return t;
    if (typeof sessionStorage !== "undefined") {
      const legacy = sessionStorage.getItem(SESSION_TOKEN_KEY);
      if (legacy && legacy.length > 0) {
        writeStoredToken(legacy);
        sessionStorage.removeItem(SESSION_TOKEN_KEY);
        return legacy;
      }
    }
    return null;
  } catch {
    return null;
  }
}

export function writeStoredToken(token: string): void {
  try {
    localStorage.setItem(SESSION_TOKEN_KEY, token);
  } catch {
    /* storage unavailable */
  }
}

export function clearStoredToken(): void {
  try {
    localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
